import React, { Component } from 'react'
import { observer } from 'mobx-react'

import FormController from '../../form/FormController'
import Panel from '../../../UniformComponents/Panel'
import BubbleLoader from '../../../UniformComponents/BubbleLoader'

@observer
export default class TemplateDetails extends Component {
    constructor(props) {
        super(props)
        this.fields = {}
    }

    async componentDidMount() {
        const { wizardStore } = this.props
        await wizardStore.initTemplateDetails()
        wizardStore.handleValidate = this.validate
    }

    validate = () => {
        const { wizardStore } = this.props
        const { formData } = wizardStore.templateDetails
        return wizardStore.validate(this.fields, formData)
    }

    renderLoader = () => <BubbleLoader cssClass="loader" />

    render() {
        const { wizardStore } = this.props
        return (
            <Panel cssClass="stage-card overflow-visible template-details">
                <div id="survey-details">
                    {
                        wizardStore.templateDetails.formLoading ? this.renderLoader()
                            : (
                                <FormController
                                    fields={this.fields}
                                    formFields={wizardStore.templateDetails.formFields}
                                    setField={wizardStore.setTemplateDetailsField}
                                    appStore={wizardStore.appStore}
                                />
                            )
                    }
                </div>
            </Panel>
        )
    }
}
